import api from "./axios";
import { getEmployeeName } from "./currentUser";

export interface ChatUser {
  LoginID: string;
  employeename: string;
  role?: string;
  roleid?: number | string;
  roleId?: number | string;
  role_id?: number | string;
}

export interface CurrentUser {
  LoginID: string;
  employeename: string;
  role: string;
  roleid: number;
}

export interface LastMessage {
  _id: string;
  text: string;
  sender: ChatUser;
  createdAt: string;
}

export interface Conversation {
  _id: string;
  type: "dm" | "group";
  participants: ChatUser[];
  groupName?: string;
  groupAdmin?: ChatUser | null;
  lastMessage?: LastMessage | null;
  unreadCount: number;
  createdAt: string;
  updatedAt: string;
}

export interface Message {
  _id: string;
  conversationId: string;
  sender: ChatUser;
  text: string;
  mediaUrl?: string | null;
  isDeleted: boolean;
  readBy: string[];
  createdAt: string;
  updatedAt: string;
}

const decodeJwt = (token: string): any => {
  try {
    const base64Url = token.split(".")[1];
    if (!base64Url) return null;
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const json = decodeURIComponent(
      window
        .atob(base64)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join("")
    );
    return JSON.parse(json);
  } catch {
    return null;
  }
};

export const getCurrentUser = (): CurrentUser | null => {
  try {
    const raw = localStorage.getItem("userData");
    if (raw) {
      const data = JSON.parse(raw);
      if (data?.employeeid) {
        return {
          LoginID: String(data.employeeid),
          employeename: data.employeename,
          role: data.role,
          roleid: data.roleid,
        };
      }
    }
  } catch {
  }

  const token = localStorage.getItem("token") || sessionStorage.getItem("token");
  if (!token) return null;

  const decoded = decodeJwt(token);
  if (!decoded) return null;

  const loginId =
    decoded.employeeid ?? decoded.empid ?? decoded.EmployeeID ?? decoded.LoginID ?? decoded.id;
  if (loginId === undefined || loginId === null || loginId === "") return null;

  return {
    LoginID: String(loginId),
    employeename: getEmployeeName(),
    role: decoded.role || decoded.Role || "",
    roleid: Number(decoded.roleid ?? decoded.RoleID ?? localStorage.getItem("roleid")) || 0,
  };
};

export const getChatUsersApi = () => api.get("/chat/users");

export const getChatConversationsApi = () =>
  api.get("/chat/conversations");

export const startDMApi = (recipientId: string) =>
  api.post("/chat/conversations/dm", { recipientId });

export const createGroupApi = (
  groupName: string,
  memberIds: string[]
) =>
  api.post("/chat/conversations/group", {
    groupName,
    memberIds,
  });

export const getChatMessagesApi = (
  conversationId: string,
  page = 1,
  limit = 30
) =>
  api.get(
    `/chat/messages/${conversationId}?page=${page}&limit=${limit}`
  );

export const sendChatMessageApi = (
  conversationId: string,
  text: string,
  mediaUrl?: string | null
) =>
  api.post(`/chat/messages/${conversationId}`, {
    text,
    ...(mediaUrl ? { mediaUrl } : {}),
  });

export const uploadChatFileApi = (file: File) => {
  const formData = new FormData();
  formData.append("file", file);
  return api.post("/chat/upload", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};
